import { Sites } from '@ps/platform-message-framework/common/Sites';
import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import { format } from 'date-fns';
import React from 'react';
import { useSelector } from 'react-redux';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import { select } from '@swf/core/store';

import { ExclusionTime } from '../../../shared/definitions';
import type { ExclusionResponseProps } from '../../definitions';

import {
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_5,
  TXTWCL_WeXll_automatically_reopen_you_ELL
} from './DefaultBreakResponse.messages.json';

type Props = Omit<ExclusionResponseProps, 'exclusionType'>;

const DefaultBreakResponse: React.FC<Props> = ({ daysRequested, endDate }) => {
  const site = useSelector(select.cms.getSiteId);
  const isCOMHalfYearBreak =
    site === Sites.COM && daysRequested === ExclusionTime.HundredEightyDays;

  return (
    <div>
      <Translation
        {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_5}
        values={{ 0: <b>{format(endDate, 'Pp')}</b> }}
      />{' '}
      {!isCOMHalfYearBreak && (
        <>
          <Translation
            {...TXTWCL_WeXll_automatically_reopen_you_ELL}
            values={{
              a: (msg: React.ReactNode) => (
                <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
              )
            }}
          />{' '}
        </>
      )}
    </div>
  );
};

export default DefaultBreakResponse;
